import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { CompanyTable } from "@/components/data-table/predefined/company-table";
import {
  companyTableDefaultColumns,
  type CompanyTableType,
} from "@/components/data-table/predefined/company-table-columns";
import type { ImplementedColumnDef } from "@/components/data-table/types";
import { CompanyTypeFilter } from "@/components/filter/predefined/company-type-filter";
import { DeletedStatusFilter } from "@/components/filter/predefined/deleted-status-filter";
import { useMemo, type ReactElement } from "react";

const COMPANY_GROUP_COMPANY_COLUMNS = [
  companyTableDefaultColumns.columnMobileSummary,
  companyTableDefaultColumns.columnName,
  companyTableDefaultColumns.columnType,
  companyTableDefaultColumns.columnSapPrefix,
  companyTableDefaultColumns.columnVatId,
  companyTableDefaultColumns.columnV1Id,
  companyTableDefaultColumns.columnTechnicalId,
  companyTableDefaultColumns.columnDeletedAt,
] as ImplementedColumnDef<CompanyTableType, unknown>[];

const RELATED_COMPANY_ROW_ACTIONS = {
  showView: false,
  showEdit: false,
  showDelete: false,
  showRestore: false,
} as const;

export function CompaniesTab({ companyGroupUuid }: { companyGroupUuid: string }): ReactElement {
  const filters = useMemo(() => [new CompanyTypeFilter(), new DeletedStatusFilter()], []);

  return (
    <CompanyTable
      name="company-group-companies"
      body={{ companyGroup: [companyGroupUuid] }}
      columns={COMPANY_GROUP_COMPANY_COLUMNS}
      filters={filters}
      showCreateButton={false}
      showExportButton={false}
      defaultRowActions={RELATED_COMPANY_ROW_ACTIONS}
      onRowNavigate={createRowNavigatePath("/masterdata/company")}
    />
  );
}
